import { FC, useCallback, useMemo } from 'react'

import { useTranslation } from '../../../../app/_providers/TranslationProvider.client'
import { CartContainer } from '../../../../brunswick/containers/cart'
import { normalizeCategoryFilter } from '../BulkPage'
import { BulkContainer } from '../containers/BulkContainer'

import { BagTotal } from './BagTotal'
import { CategoryIcon } from './CategoryIcon'
import {
  BagCategories,
  BagTitle,
  BottomContainer,
  CategoryItem,
  Container,
  MyBag,
  TotalItems,
} from './styles'
import { ViewOrderButton } from './ViewOrderButton'

export const BulkBag: FC = () => {
  const { cart } = CartContainer.useContainer()

  const { categoryFilters } = BulkContainer.useContainer()

  const {
    magnolia: {
      account: { total },
    },
    cart: { title },
  } = useTranslation()

  const getTotalCartCount = useCallback(() => {
    return Object.values(cart?.items || {}).reduce((acc, item) => acc + item.quantity, 0)
  }, [cart?.items])

  const filterCartItemsByProductType = useCallback(
    (productType: string) => {
      const normalizedProductType = normalizeCategoryFilter(productType)
      return Object.values(cart?.items || {}).filter(item => {
        const normalizedItemType = normalizeCategoryFilter(
          item.productGroup?.rawCategory ?? item.productType
        )
        return normalizedItemType === normalizedProductType
      })
    },
    [cart?.items]
  )

  const quantityPerCategory = useMemo(
    () =>
      categoryFilters.map(filter => {
        const filteredItems = filterCartItemsByProductType(filter.value)
        const totalQuantity = filteredItems.reduce((sum, item) => sum + item.quantity, 0)
        return {
          ctaText: filter.ctaText,
          category: filter.value,
          quantity: totalQuantity,
        }
      }),
    [categoryFilters, filterCartItemsByProductType]
  )

  const totalPrice = cart.totalPrice

  return (
    <Container>
      <BagCategories>
        <MyBag>
          <BagTitle>{title}:</BagTitle>
          <TotalItems>
            {getTotalCartCount()} {total}
          </TotalItems>
        </MyBag>

        {quantityPerCategory.map(({ ctaText, category, quantity }) => (
          <CategoryItem key={category}>
            <CategoryIcon ctaText={ctaText} category={category} quantity={quantity} />
          </CategoryItem>
        ))}
      </BagCategories>
      <BottomContainer>
        <BagTotal totalPrice={totalPrice} />
        <ViewOrderButton />
      </BottomContainer>
    </Container>
  )
}
